var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftWord(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    id: "microsoft-word",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#41A5EE",
    d: "M45.9538 2H13.2089C12.0789 2 11.1628 2.91609 11.1628 4.04614V13.1628L30.1395 18.7442L48 13.1628V4.04614C48 2.91609 47.0839 2 45.9538 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B7CD3",
    d: "M48 13.1628H11.1628V24.3256L30.1395 27.6745L48 24.3256V13.1628Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#185ABD",
    d: "M11.1628 24.3256V35.4883L29.0232 37.7209L48 35.4883V24.3256H11.1628Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#103F91",
    d: "M13.2089 46.6512H45.9539C47.0839 46.6512 48 45.7351 48 44.605V35.4884H11.1628V44.605C11.1628 45.7351 12.0789 46.6512 13.2089 46.6512Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24.7445 10.9302H11.1628V38.8371H24.7445C25.8731 38.8335 26.787 37.9195 26.7907 36.791V12.9763C26.787 11.8478 25.8731 10.9338 24.7445 10.9302Z",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23.6283 12.0465H11.1628V39.9535H23.6283C24.7568 39.9498 25.6707 39.0359 25.6744 37.9073V14.0927C25.6707 12.9641 24.7568 12.0502 23.6283 12.0465Z",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23.6283 12.0465H11.1628V37.7209H23.6283C24.7568 37.7172 25.6707 36.8033 25.6744 35.6748V14.0927C25.6707 12.9641 24.7568 12.0502 23.6283 12.0465Z",
    opacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22.512 12.0465H11.1628V37.7209H22.512C23.6405 37.7172 24.5544 36.8033 24.5581 35.6748V14.0927C24.5544 12.9641 23.6405 12.0502 22.512 12.0465Z",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_147648_1467)",
    d: "M2.04614 12.0465H22.512C23.642 12.0465 24.5581 12.9626 24.5581 14.0927V34.5585C24.5581 35.6886 23.642 36.6047 22.512 36.6047H2.04614C0.916088 36.6047 0 35.6886 0 34.5585V14.0927C0 12.9626 0.916088 12.0465 2.04614 12.0465Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.39667 27.7391C8.43685 28.055 8.46364 28.3296 8.47591 28.5652H8.52279C8.54065 28.3419 8.57785 28.0729 8.63441 27.7581C8.69098 27.4433 8.74196 27.1773 8.78735 26.96L10.9395 17.6748H13.7224L15.955 26.8204C16.0847 27.3891 16.1775 27.9656 16.2329 28.5462H16.2698C16.3114 27.9837 16.389 27.4244 16.502 26.8718L18.2824 17.6703H20.8153L17.6874 30.9763H14.7282L12.6073 22.1644C12.5459 21.911 12.4756 21.5795 12.3985 21.172C12.3215 20.7646 12.2735 20.4665 12.2545 20.279H12.2177C12.1931 20.4956 12.1451 20.8171 12.0737 21.2435C12.0022 21.6699 11.9449 21.9854 11.9018 22.1901L9.90807 30.9741H6.89858L3.75404 17.6747H6.33263L8.27162 26.9789C8.31517 27.1698 8.35648 27.4243 8.39667 27.7391Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_147648_1467",
    x1: 4.266,
    x2: 20.292,
    y1: 10.448,
    y2: 38.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2368C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A5DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1146AC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftWord);
export default __webpack_public_path__ + "static/media/microsoft-word.834bcc8e93a322b5bf7287713b2e3900.svg";
export { ForwardRef as ReactComponent };